import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import ParentService from '../../services/parentServices';
import { clearAuth } from 'store/auth';
import { isObject } from 'lodash';

export const getList = createAsyncThunk('parent/list', async ({ status, page, perPage, sort, orderBy, search }, thunkAPI) => {
  try {
    const response = await ParentService.getList(status, page, perPage, sort, orderBy, search);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('parent/create', async (data, thunkAPI) => {
  try {
    const response = await ParentService.create(data);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
   
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('parent/read', async (id, thunkAPI) => {
  try {
    const response = await ParentService.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('parent/update', async (data, thunkAPI) => {
  try {
    const response = await ParentService.update(data.id, data);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('parent/delete', async (id, thunkAPI) => {
  try {
    const response = await ParentService.del(id);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changeStatus = createAsyncThunk('parent/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await ParentService.changeStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updatePhoto = createAsyncThunk('parent/updatePhoto', async ({ id, photo }, thunkAPI) => {
  try {
    const response = await ParentService.updatePhoto(id, photo);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deletePhoto = createAsyncThunk('parent/deletePhoto', async (id, thunkAPI) => {
  try {
    const response = await ParentService.deletePhoto(id);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const addBank = createAsyncThunk('parent/addBank', async ({ id, data }, thunkAPI) => {
  try {
    const response = await ParentService.addBank(id, data);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateBank = createAsyncThunk('parent/updateBank', async ({ id, bankID, data }, thunkAPI) => {
  try {
    const response = await ParentService.updateBank(id, bankID, data);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteBank = createAsyncThunk('parent/deleteBank', async ({ id, bankID }, thunkAPI) => {
  try {
    const response = await ParentService.deleteBank(id, bankID);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], data: [], error: [] };

const parentSlice = createSlice({
  name: 'parent',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = isObject(action.payload.errors) ? action.payload.errors : [];
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = isObject(action.payload.errors) ? action.payload.errors : [];
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updatePhoto.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updatePhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(updatePhoto.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addBank.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(addBank.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(addBank.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateBank.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateBank.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(updateBank.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteBank.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteBank.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(deleteBank.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = parentSlice;
export default reducer;
